/**
 * Client detail responses can briefly be empty while a refresh is pending or
 * when the API rejects a read. Keep tab components on a stable object shape.
 */
const objectValue = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : {};

const linkedClient = (value) => {
  const source = objectValue(value);
  if (!source.id) return null;
  return {
    id: Number(source.id),
    first_name: String(source.first_name || ""),
    last_name: String(source.last_name || ""),
  };
};

export const normalizeClientRelationship = (detail) => {
  const source = objectValue(objectValue(detail).relationship);
  const role = source.role === "parent" || source.role === "child" ? source.role : null;
  return {
    role,
    parent: linkedClient(source.parent),
    children: Array.isArray(source.children) ? source.children.map(linkedClient).filter(Boolean) : [],
  };
};

export const appointmentContact = (detail) => {
  const source = objectValue(detail);
  const resolved = objectValue(source.appointment_contact);
  return {
    email: resolved.email ?? source.email ?? "",
    phone_number: resolved.phone_number ?? source.phone_number ?? "",
    country_code: resolved.country_code ?? source.country_code ?? "",
    email_source_client_id: resolved.email_source_client_id ?? source.id ?? null,
    phone_source_client_id: resolved.phone_source_client_id ?? source.id ?? null,
    email_inherited: resolved.email_inherited === true,
    phone_inherited: resolved.phone_inherited === true,
  };
};

export const normalizeClientDetail = (detail) => {
  const source = objectValue(detail);
  if (!Object.keys(source).length) return {};
  return {
    ...source,
    relationship: normalizeClientRelationship(source),
    appointment_contact: appointmentContact(source),
  };
};

export const clientRequiresOwnContact = (detail) => {
  const relationship = normalizeClientRelationship(detail);
  return relationship.role !== "child" || !relationship.parent;
};

export const clientDetailId = (detail) => normalizeClientDetail(detail).id || "";

/** Convert HandleError payloads into values React can safely render. */
export const readableClientHistoryError = (error, fallback = "Unable to load client history.") => {
  if (typeof error === "string") return error;
  if (error && typeof error.message === "string") return error.message;
  if (error && error.message && typeof error.message.message === "string") return error.message.message;
  if (error && typeof error.error === "string") return error.error;
  return fallback;
};

export default {
  normalizeClientDetail,
  normalizeClientRelationship,
  appointmentContact,
  clientRequiresOwnContact,
  clientDetailId,
  readableClientHistoryError,
};
